import React from 'react';
import classNames from 'classnames';
import iconBotImg from '../../../assets/img/icon-bot.png';
import replace from '../../../helpers/markdownReplacer';

const WitMessage = ({ message }) => {

  const { answer, links } = message;

  const renderLinks = () => {
    if (!links || links.length === 0) {
      return;
    }

    let i = 0;
    return links.map((link) => {
      i++;
      return <div className="option-link" key={`question-${i}`}
                  dangerouslySetInnerHTML={{ __html: replace(link) }} />;
    });
  };

  return (
    <>
      <div className={
        classNames({
          'message-wrapper': true,
          bot: true,
        })
      }>
        <div className={
          classNames({
            icon: true,
            bot: true,
          })
        }>
          <img src={iconBotImg} alt="" />
        </div>

        {answer ? (
          <div className={
            classNames({
              message: true,
              bot: true,
            })
          }>
            <div dangerouslySetInnerHTML={{ __html: replace(answer) }} />
          </div>
        ) : (
          <div className="inner-options">
            {renderLinks()}
          </div>
        )}
      </div>
    </>
  );
};

export default WitMessage;
